module.exports = __webpack_public_path__ + "static/media/gryphon_x_ids_logos.76cc288b.svg";